/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.unitModule')
.directive('bulbUnitBreadcrumb', bulbUnitBreadcrumb);

function bulbUnitBreadcrumb() {

  var controller = function($rootScope, $scope, $translate, BulbAuthService, BulbUnitDroppableService, AUTH) {

    this.breadcrumbList = [];
    this.ownerAvatarImage = null;
    this.readOnly = $scope.readOnly = !BulbAuthService.currentUser.hasPermission(this.unit, AUTH.PERMISSIONS.UPDATE);

    var that = this;
    var ancestorUnits = that.unit.ancestorUnits;

    var createBreadcrumbForDeletedHome = function (unit) {
      var userUnit = angular.copy(unit);
      var uiSref = 'unit({unitPath: \'' + userUnit.path + '\'})';
      userUnit.name = $translate.instant('soft_delete_home');
      userUnit.unitType = 'DeletedUserUnit';
      that.breadcrumbList.push(angular.merge({}, userUnit, {
        uiSref: uiSref,
        isUserUnit: unit.unitType === 'UserUnit'
      }));
    };

    angular.forEach(ancestorUnits, function(unit) {
      var uiSref = 'unit({unitPath: \'' + unit.path + '\'})';
      if (unit.unitType === 'UserUnit') {
        uiSref = 'author({username: \'' + unit.ownerUsername + '\' })';
        // Use case if the user has removed their display name:
        if ( !unit.name ) {
          unit.name = $translate.instant( 'organization_dashboard_back_to_profile' );
        }
        // If unit is deleted then show Deleted as unit name instead of user name.
        if (that.unit.deleteAfterDays > 0) {
          createBreadcrumbForDeletedHome(unit);
          unit.name = $translate.instant('soft_delete_home_recently_deleted');
        }
      } else if (unit.unitType === 'GroupUnit') {
        uiSref = 'group({groupUrl: \'' + unit.path + '\'})';
      }
      that.breadcrumbList.push(angular.merge({}, unit, {
        uiSref: uiSref,
        isUserUnit: unit.unitType === 'UserUnit'
      }));
    });

    if (that.unit.unitType === 'CompositeUnit' || that.unit.unitType === 'AssignmentCompositeUnit') {
      that.breadcrumbList.push(angular.merge({}, that.unit, {uiSref: null}));
    }

    this.onEntryDrop = function(event, ui, dropTargetUnit) {
      BulbUnitDroppableService.onUnitDroppable(that.unit.children, ui.draggable.scope().childUnit, dropTargetUnit);
    };

    /**
     * Broadcast event when user click on link for deleted unit.
     * @param unit Selected unit.
     */
    this.broadcastForDeletedUnit = function(unit) {
      $rootScope.$broadcast('openDeletedCollection', unit);
    };
  };

  return {
    restrict: 'E',
    scope: true,
    bindToController: {
      unit: '='
    },
    templateUrl: 'ajs/unit/breadcrumb.html',
    controller: ['$rootScope', '$scope', '$translate', 'BulbAuthService', 'BulbUnitDroppableService', 'AUTH', controller],
    controllerAs: 'breadcrumbCtrl'
  };
}
